import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { listWorkflows } from "../../../api/content/workflowsApi";
import { useLoad } from "../../../shared/loading/useLoad";
import { editIntent } from "../../threads/prepare/author/authorChoices";
import { useThreadPreparation } from "../../threads/prepare/useThreadPreparation";
import { useHerePath } from "../../threads/prepare/useHerePath";
import ModalShell from "../../../ui/overlays/ModalShell";
import type { ProcessSearchItem } from "./processSearchApi";
import LoadStatus from "../../../ui/feedback/LoadStatus";

/** Carry the exact selected version into an edit of an existing Workflow, by hand: its draft gets it, nothing is saved yet (ADR-0031 D2). */
export default function UseInWorkflow({ projectId, item, onClose }: { projectId: string; item: ProcessSearchItem; onClose: () => void }) {
  const { t } = useTranslation();
  const preparation = useThreadPreparation();
  const here = useHerePath();
  const load = useCallback((signal: AbortSignal) => listWorkflows(projectId, null, signal), [projectId]);
  const { state, reload } = useLoad(load);
  const workflows = state.status === "loaded" ? state.value.workflows.filter((workflow) => workflow.reference.split("@")[0] !== item.itemId) : [];
  return (
    <ModalShell title={t("authoring.similar.use")} subtitle={item.name} onClose={onClose} size="lg">
      <LoadStatus state={state} loadingLabel={t("authoring.similar.loading")} onRetry={reload} />
      {state.status === "loaded" && workflows.length === 0 ? <p className="app-text-muted text-sm">{t("authoring.similar.noWorkflows")}</p> : null}
      <ul className="space-y-2">
        {workflows.map((workflow) => (
          <li key={workflow.reference}>
            <button
              type="button"
              className="app-link text-sm underline"
              onClick={() => {
                preparation.prepare(editIntent(projectId, { itemKind: "workflow", name: workflow.name, reference: workflow.reference }, here, { way: "by_hand", carry: item.reference }));
                onClose();
              }}
            >
              {workflow.name}
            </button>
          </li>
        ))}
      </ul>
    </ModalShell>
  );
}
